import styles from './index.module.sass';
import TextInput from 'componets/text-input';
import iconInfo from 'images/icon-info.svg';
import { PASSWORD_CHAR_REGEX } from 'helpers/rule-validation';

const UpdatePassword = ({
  oldPassword = undefined,
  oldPasswordErrorMessage,
  onChangeOldPassword,
  newPassword,
  newPasswordErrorMessage,
  onChangeNewPassword,
  confirmedPassword,
  confirmedPasswordErrorMessage,
  onChangeConfirmedPassword,
  onOldPasswordFocus,
  onNewPasswordFocus,
  onConfirmedPasswordFocus,
  onUpdatePassword,
}) => {
  const OldPassword = () => {
    return (
      <div className={styles['form-input']}>
        <TextInput
          type="password"
          label="原密碼"
          placeholder="輸入原密碼"
          digits={PASSWORD_CHAR_REGEX}
          newText={oldPassword}
          errorMessage={oldPasswordErrorMessage}
          onTextChange={onChangeOldPassword}
          onFocus={onOldPasswordFocus}
        />
      </div>
    );
  };

  return (
    <div className={styles.form}>
      {oldPassword !== undefined && <OldPassword />}
      <div className={styles['form-input']}>
        <TextInput
          type="password"
          label="新密碼"
          placeholder="輸入新密碼"
          digits={PASSWORD_CHAR_REGEX}
          newText={newPassword}
          errorMessage={newPasswordErrorMessage}
          onTextChange={onChangeNewPassword}
          onFocus={onNewPasswordFocus}
        />
      </div>
      <div className={styles['form-input']}>
        <TextInput
          type="password"
          label="確認新密碼"
          placeholder="再次輸入新密碼"
          digits={PASSWORD_CHAR_REGEX}
          newText={confirmedPassword}
          errorMessage={confirmedPasswordErrorMessage}
          onKeyPressEnter={onUpdatePassword}
          onTextChange={onChangeConfirmedPassword}
          onFocus={onConfirmedPasswordFocus}
        />
      </div>
      <div className={styles.hint}>
        <img src={iconInfo} alt="info" />
        密碼必須包含至少 8 個字元，可以混合使用英文字母、數字和符號。
      </div>
    </div>
  );
};

export default UpdatePassword;
